import React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import "./CourseTopicMaterials.css";
import ReactPlayer from "react-player";


const Container = styled('div')({
  display: 'flex',
});

const LeftImageContainer = styled('div')({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
});

const AccordionContainer = styled('div')({
  flex: 5,
  display: 'flex',
  flexDirection: 'column',
});

const RightImageContainer = styled('div')({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
});

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme, expanded }) => ({
  border: `1px solid ${theme.palette.divider}`,
  marginBottom: expanded ? theme.spacing(2) : 0,
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgb(53, 36, 117)'
      : 'rgb(53, 36, 117)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const useAccordion = () => {
  const [expanded, setExpanded] = React.useState([]);

  const handleChange = (panel) => (event, isExpanded) => {
    if (isExpanded) {
      setExpanded([...expanded, panel]);
    } else {
      setExpanded(expanded.filter((id) => id !== panel));
    }
  };

  return { expanded, handleChange };
};

const CourseTopicMaterials = ({ items, leftImage, rightImage }) => {
  const { expanded, handleChange } = useAccordion();
  

  return (
    <div className='formCourseMaterials'>
      <Container>
        <LeftImageContainer>
          <img className='pageDetailsImage' src={leftImage} style={{marginLeft: "5rem"}} alt="Pic 1" width="200" height="300" /> 
        </LeftImageContainer>

        <AccordionContainer>
          {items.map((accordion) => {
            const { id, ariaControls, headerId, topic, details, videos } = accordion;

            return (
              <Accordion style={{width: "71.5%", marginLeft: "14%"}} key={id} expanded={expanded.includes(id)} onChange={handleChange(id)}>
                <AccordionSummary aria-controls={ariaControls} id={headerId}>
                  <Typography>{topic}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className='topicDescription'>{details}</Typography>
                  <div>
                    {videos.map((video, index) => (
                      <React.Fragment key={video.id}>
                        <h1 className='videoLabel'>{video.label}</h1>
                        <ReactPlayer onContextMenu={e => e.preventDefault()} className='languageVideos' key={index} url={video.url} controls={true} config={{ file: { attributes: { preload: 'none', controlsList: 'nodownload' }}}} />
                      </React.Fragment>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </AccordionContainer>

        <RightImageContainer>
          <img className='pageDetailsImage' src={rightImage} style={{marginRight: "5rem"}} alt="Pic 2" width="200" height="300" /> 
        </RightImageContainer>
      </Container>
    </div>
  );
};

export default CourseTopicMaterials;
